import type { FC } from 'react';

import { HelpChapterProps } from '../../../../api/fetchers/help/fetcher';
import { GameButton } from '../../../game/gameButton/gameButton';
import { Icons } from '../../../icons/iconNames';
import { HelpComponentWrapper } from '../../utils/HelpComponentWrapper';
import { HelpText } from '../../utils/HelpText';

export const HelpChapterAutoplay: FC<HelpChapterProps> = ({ content }) => {
  if (!content) return null;

  return (
    <div>
      <p>
        <HelpText>{String(content.autoplayFeature)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <GameButton icon={Icons.Autoplay} border />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.autoplayWindow)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.autoplayButton)}</HelpText>
      </p>
      <HelpComponentWrapper>
        <GameButton icon={Icons.Autoplay} border badge={45} />
      </HelpComponentWrapper>
      <p>
        <HelpText>{String(content.autoplayModify)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.autoplayStop)}</HelpText>
      </p>
      <p>
        <HelpText>{String(content.autoplayAutoStop)}</HelpText>
      </p>
      <ul>
        <li>{String(content.stopZero)}</li>
        <li>{String(content.stopBalance)}</li>
        <li>{String(content.stopChanges)}</li>
      </ul>
    </div>
  );
};
